import React from "react";
import NetworkBackground from "./components/background/NetworkBackground";
import Home from "./Home";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <div className="w-full lgl:h-screen font-bodyfont overflow-hidden text-textColor bg-pageColor relative">
      <Analytics />
      <div className="max-w-screen-2xl h-full mx-auto flex justify-center items-center">
        <Home />
      </div>
      <div className="w-full h-full absolute top-0 left-0 z-10 pointer-events-none">
        <NetworkBackground />
      </div>
    </div>
  );
}

export default App;
